import React from 'react';
import i18n from '@/utils/i18n';
import { EventsListWithFilter } from './components/EventListWithTimeFilter';
import { MainHeader } from '../../components/Layout/MainHeader';
import { ContentSection } from '../../components/Layout/ContentSection';
import { isDev, isLocalDev } from '@/utils/isDev';
import { useDocumentTitle } from '@/hooks/useDocumentTitle';

export const EventsIndexView = () => {
  const isDevelopmentEnv = isDev() || isLocalDev();

  useDocumentTitle('PageTitles:events');

  return (
    <div>
      <MainHeader
        title={i18n.t('Events:events')}
        rightButton={
          isDevelopmentEnv
            ? {
                label: i18n.t('Events:createNewEvent') + ' (on dev only)',
                link: '/event/create',
              }
            : undefined
        }
      />

      <ContentSection title={i18n.t('Events:events')} collapsable={false}>
        <EventsListWithFilter />
      </ContentSection>
    </div>
  );
};
